<template>
    <b-container>
        <b-row style="text-align:left">
            <b-col cols="12" lg="4">
                <b-form-group>
                    <span style="font-weight:bold">Processo:</span>
                    <span style="margin-left:5px">{{ protocolo.Numero }}</span>
                </b-form-group>
            </b-col>
            <b-col cols="12" lg="4">
                <b-form-group>
                    <span style="font-weight:bold">Assunto:</span>
                    <span style="margin-left:5px">{{ protocolo.Assunto }}</span>
                </b-form-group>
            </b-col>
            <b-col cols="12" lg="4">
                <b-form-group>
                    <span style="font-weight:bold">Data de Entrada:</span>
                    <span style="margin-left:5px">{{ formatData(protocolo.DataEntrada) }}</span>
                </b-form-group>
            </b-col>
            <b-col cols="12" lg="4">
                <b-form-group>
                    <span style="font-weight:bold">Unidade Gestora:</span>
                    <span style="margin-left:5px">{{ protocolo.UnidadeGestora }}</span>
                </b-form-group>
            </b-col>
            <b-col cols="12" lg="4">
                <b-form-group>
                    <span style="font-weight:bold">Tipo do Protocolo:</span>
                    <span style="margin-left:5px">{{ protocolo.TipoDocumento }}</span>
                </b-form-group>
            </b-col>
            <b-col cols="12" lg="4">
                <b-form-group>
                    <span style="font-weight:bold">Área Atual:</span>
                    <span style="margin-left:5px">{{ protocolo.AreaAtual }}</span>
                </b-form-group>
            </b-col>
            <b-col cols="12" lg="4">
                <b-form-group>
                    <span style="font-weight:bold">Situação Atual:</span>
                    <span style="margin-left:5px">{{ protocolo.SituacaoAtual }}</span>
                </b-form-group>
            </b-col>
            <b-col cols="12" lg="4">
                <b-form-group>
                    <span style="font-weight:bold">Relator:</span>
                    <span style="margin-left:5px">RELATOR NÃO INFORMADO</span>
                </b-form-group>
            </b-col>
            <b-col cols="12" lg="4">
                <b-form-group>
                    <span style="font-weight:bold">Ano Ofício:</span>
                    <span style="margin-left:5px">{{ protocolo.AnoOficio }}</span>
                </b-form-group>
            </b-col>
            <b-col cols="12" lg="4">
                <b-form-group>
                    <span style="font-weight:bold">Comentário:</span>
                    <span style="margin-left:5px">{{ protocolo.Comentario }}</span>
                </b-form-group>
            </b-col>

            <b-col cols="12" lg="4">
                <b-form-group>
                    <span style="font-weight:bold">Interessado Principal:</span>
                    <span style="margin-left:5px">{{ protocolo.Interessados }}</span>
                </b-form-group>
            </b-col>
            <b-col cols="12" lg="4">
                <b-form-group>
                    <span style="font-weight:bold">Observações:</span>
                    <span style="margin-left:5px"> {{ protocolo.Observacoes }}</span>
                </b-form-group>
            </b-col>
            <b-col cols="12" lg="4">
                <b-form-group>
                    <span style="font-weight:bold">Prioritário:</span>
                    <span style="margin-left:5px"> {{ protocolo.Prioritario ? "Sim" : "Não" }}</span>
                </b-form-group>
            </b-col>
            <b-col v-if="protocolo.cancelado" cols="12" lg="4">
                <b-form-group>
                    <span style="font-weight:bold">Motivo do Cancelamento:</span>
                    <span style="margin-left:5px"> {{ protocolo.MotivoCancelamento }}</span>
                </b-form-group>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import { UtilsTS } from '@/utilsts'

export default {
    name: 'DetalheProtocolo',
    mixins: [UtilsTS],
    props: ["protocolo"]
}
</script>
<style>
</style>
